<template>
  <div class="top">
    <div class="img">
      <img :src="userinfo.avatars" alt="" v-if="userinfo.avatars" />
      <img src="/static/customer/userimg.jpg" alt="" v-else />
    </div>
    <div class="text">
      <div class="title" v-if="userinfo.name1">{{ userinfo.name1 }}</div>
      <div class="title" v-else>{{ userinfo.username }}</div>
      <div class="info">
        <p v-if="userinfo.niceName">联系负责人：{{ userinfo.niceName }}</p>
        <p>联系电话：{{ userinfo.phone }}</p>
      </div>
    </div>
    <div class="btn" @click="ismessagefun">修改信息</div>
    <Message v-if="ismessage" @ishidefun="ismessagefun"></Message>
  </div>
</template>

<script>
import Message from '../message/message.vue'

export default {
  name: 'top',
  data () {
    return {
      ismessage: false
    }
  },
  components: {
    Message
  },
  computed: {
    userinfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    ismessagefun () {
      this.ismessage = !this.ismessage
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./top.scss";
</style>



// WEBPACK FOOTER //
// src/components/customer/top/top.vue